//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgSquareInfo } from '../icons/SquareInfo';

export function SquareInfoIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgSquareInfo} data-qa="SquareInfoIcon">
      <svg />
    </SvgIcon>
  );
}
